import React from 'react'
import { Link } from 'react-router-dom'
import { ButtonLinkSmall } from '../../components/buttons'

import profileImage from '../../images/profile-image.png'
import bubbleLogo from '../../images/bubble-logo-2.svg'
import personIcon from '../../images/icons/icon--person.svg'
import peopleIcon from '../../images/icons/icon--people.svg'
import calendarIcon from '../../images/icons/icon--calendar.svg'
import closeIcon from '../../images/icons/icon--close.svg'
import addIcon from '../../images/icons/icon--add.svg'
import exclamationIcon from '../../images/icons/icon--exclamation.svg'

export const Profile = ({ user, location, people, removePerson }) => {
  if (location.state && location.state.newAccount) {
    return null
  }

  return (
    <>
      <section className="bg-purple-light bg-opacity-25 border-b-1 border-gray-200 relative overflow-hidden">
        <div className="container-xxl sm:flex justify-between items-center py-32">
          <div className="flex flex-col sm:flex-row items-center sm:mr-20">
            <img
              className="hidden sm:block pointer-events-none absolute -top-3/4 -right-24 opacity-50"
              src={bubbleLogo}
              alt=""
            />
            <img
              className="relative border-3 border-purple-light rounded-full mb-20 sm:mb-0"
              src={profileImage}
              alt={`${user.profile.firstName} ${user.profile.lastName}`}
            />
            <div className="relative text-purple-dark mb-32 sm:mb-0 sm:ml-40">
              <p className="text-30 font-normal mb-12">
                {user.profile.firstName} {user.profile.lastName}
              </p>
              <p className="mb-12 flex items-center">
                <img className="mr-16" src={personIcon} alt="" />
                <span>Not vaccinated</span>
              </p>
              <p className="flex items-center">
                <img className="mr-16" src={personIcon} alt="" />
                <span>Mindful</span>
              </p>
            </div>
          </div>
          <ButtonLinkSmall
            to="/edit"
            className="relative border-2 border-purple-dark text-purple-dark rounded-10"
          >
            Edit Profile
          </ButtonLinkSmall>
        </div>
      </section>
      <section className="container-lg mb-40">
        <div>
          <div className="flex flex-col sm:flex-row items-center justify-between py-48">
            <h2 className="text-purple-dark mb-32 sm:mb-0">My Bubble</h2>
            <Link className="flex items-center no-underline" to="/new">
              <img
                className="bg-pink-dark rounded-full p-12 mr-16"
                src={addIcon}
                alt=""
              />
              <span className="text-purple-dark">Add People</span>
            </Link>
          </div>
          {people && people.length > 0 ? (
            people.map((person, i) => (
              <div
                key={i}
                className="flex items-center justify-between p-24 mb-12 border-1 border-gray-200 rounded-10 bg-white shadow-100"
              >
                <div className="flex items-center">
                  <img
                    className="w-80 h-80 border-1 border-purple-light rounded-full"
                    src={profileImage}
                    alt={`${person.item.firstName} ${person.item.lastName}`}
                  />
                  <div className="text-gray-300 text-16 ml-32">
                    <p className="text-purple-dark text-18 pb-8">
                      {person.item.firstName} {person.item.lastName}
                    </p>
                    <p className="pb-8 flex items-center">
                      <img className="mr-16" src={calendarIcon} alt="" />
                      <span>You last saw Frodo on March 1, 2021</span>
                    </p>
                    <p className="flex items-center">
                      <img className="mr-16" src={peopleIcon} alt="" />
                      <span>Unconcerned</span>
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => removePerson(person.itemId)}
                  className="border-b-1 pb-4 text-purple-dark"
                >
                  <img className="mr-16" src={closeIcon} alt="" />
                  <span>Remove</span>
                </button>
              </div>
            ))
          ) : (
            <div className="bg-white border-1 border-gray-200 rounded-10 shadow-100 text-center px-20 py-32 sm:px-56 sm:py-40">
              <img className="mb-32" src={exclamationIcon} alt="" />
              <h2 className="text-22 font-normal text-purple-dark mb-20">
                Get Started by Adding to Your Bubble!
              </h2>
              <p>
                You haven’t added anyone to your bubble yet. Add people in your
                social circle to keep track of different behaviors, so you can
                make safer social decisions during COVID.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  )
}
